export default [
  {
    title: 'corporateInfo', // change to CORPORATE INFO so all namespaces in controll have to change domain to it
    icon: 'fas fa-th',
    children: [
      {
        path: '/dashboard',
        title: 'dashboard',
        permission: 'view-total-cards'
      },
      { path: '/companies', title: 'company', permission: 'view-companies' },
      { path: '/branches', title: 'branch', permission: 'view-branches' },
      {
        path: '/v2/exchange-rates',
        title: 'exchangeRate',
        permission: 'view-exchange-rates'
      },
      {
        path: '/v2/currencies',
        title: 'currency',
        permission: 'view-currencies'
      },
      {
        title: 'employee',
        children: [
          {
            path: '/divisions',
            title: 'division',
            permission: 'view-divisions'
          },
          {
            path: '/departments',
            title: 'department',
            permission: 'view-departments'
          },
          {
            path: '/positions',
            title: 'position',
            permission: 'view-positions'
          },
          {
            path: '/attendance-shifts',
            title: 'attendanceShift',
            permission: 'view-attendance-shifts'
          },
          {
            path: '/employees',
            title: 'employeeProfile',
            permission: 'view-employees'
          },
          {
            path: '/employee-card-activators',
            title: 'cardActivator',
            permission: 'view-employee-card-activators'
          },
          {
            path: '/work-schedules',
            title: 'workSchedule',
            permission: 'view-work-schedules'
          },
          {
            path: '/leave-records',
            title: 'leaveRecord',
            permission: 'view-leave-records'
          },
          {
            path: '/employee-daily-timescans',
            title: 'dailyTimescan',
            permission: 'view-employee-daily-timescans'
          },
          {
            path: '/monthly-attendences',
            title: 'monthlyAttendence',
            permission: 'view-monthly-attendances'
          }
        ]
      },
      {
        title: 'mobileFeature',
        icon: '',
        children: [
          { path: '/news', title: 'news', permission: 'view-news' },
          { path: '/abouts', title: 'aboutUs', permission: 'view-abouts' },
          {
            title: 'notification',
            children: [
              {
                path: '/notification-templates',
                title: 'templateSetup',
                permission: 'view-notification-templates'
              },
              {
                path: '/notification-schedules',
                title: 'schedule',
                permission: 'view-notification-schedules'
              },
              {
                path: '/notification-manuals',
                title: 'manualSend',
                permission: 'view-notification-manuals'
              },
              {
                path: '/notification-monitoring',
                title: 'monitoring',
                permission: 'view-notification-monitoring'
              },
              {
                path: '/notification-histories',
                title: 'history',
                permission: 'view-notification-histories'
              }
            ]
          },
          {
            path: '/reset-device-passwords',
            title: 'resetPassword',
            permission: 'view-device-passwords'
          }
        ]
      },
      {
        title: 'setting',
        icon: '',
        children: [
          {
            path: '/front-covers',
            title: 'frontCover',
            permission: 'view-front-covers'
          },
          {
            path: '/setup-landing-pages',
            title: 'landingPage',
            permission: 'view-setup-landing-pages'
          },
          { path: '/menu-structures', title: 'menuStructure', permission: '' },
          {
            path: '/holiday-rules',
            title: 'holidayRule',
            permission: 'view-holiday-rules'
          },
          { path: '/holidays', title: 'holiday', permission: 'view-holidays' },
          { path: '/report-templates', title: 'reportTemplate' },
          {
            path: '/approval-work-flows',
            title: 'ApprovalWorkFlow',
            permission: 'view-approval-work-flows'
          }
        ]
      },
      {
        path: '/file-managers',
        title: 'fileManager',
        permission: 'view-file-managers'
      }
    ]
  },
  {
    title: 'school',
    icon: 'fas fa-graduation-cap',
    children: [
      {
        title: 'customerService',
        icon: '',
        children: [
          {
            path: '/info-inquiries',
            title: 'infoInquiry',
            permission: 'view-info-inquiries'
          },
          {
            path: '/student-follow-ups',
            title: 'inquiryFollowUp',
            permission: 'view-student-follow-ups'
          }
        ]
      },
      {
        title: 'academic',
        icon: '',
        children: [
          {
            title: 'setup',
            icon: '',
            children: [
              {
                title: 'program',
                icon: '',
                children: [
                  {
                    path: '/main-programs',
                    title: 'mainProgram',
                    permission: 'view-main-programs'
                  },
                  {
                    path: '/sub-programs',
                    title: 'subProgram',
                    permission: 'view-sub-programs'
                  },
                  {
                    title: 'subject',
                    icon: '',
                    children: [
                      {
                        path: '/subject-cores',
                        title: 'coreSubjects',
                        permission: 'view-subject-cores'
                      },
                      {
                        path: '/subject-electives',
                        title: 'electiveSubjects',
                        permission: 'view-subject-electives'
                      },
                      {
                        path: '/subject-activities',
                        title: 'activitySubjects',
                        permission: 'view-subject-activities'
                      }
                    ]
                  },
                  {
                    path: '/levels',
                    title: 'level',
                    permission: 'view-levels'
                  },
                  { path: '/grades', title: 'grade', permission: 'view-grades' }
                ]
              },
              {
                path: '/academic-years',
                title: 'academicYear',
                permission: 'view-academic-years'
              },
              {
                path: '/term-semesters',
                title: 'termSemester',
                permission: 'view-terms'
              },
              {
                path: '/buildings',
                title: 'building',
                permission: 'view-buildings'
              },
              { path: '/rooms', title: 'room', permission: 'view-rooms' },
              {
                path: '/schedule-times',
                title: 'scheduleTime',
                permission: 'view-schedule-times'
              },
              {
                path: '/study-times',
                title: 'studyTime',
                permission: 'view-study-times'
              },
              {
                path: '/attendance-devices',
                title: 'attendanceDevice',
                permission: 'view-attendance-devices'
              },
              {
                title: 'scoring',
                icon: '',
                children: [
                  {
                    path: 'score-components',
                    title: 'scoreComponent',
                    permission: 'view-score-components'
                  },
                  {
                    path: 'grading-definitions',
                    title: 'gradingDefinition',
                    permission: 'view-grading-definitions'
                  }
                ]
              },
              {
                path: '/corporate-partners',
                title: 'corporatePartner',
                permission: 'view-corporate-partners'
              },
              {
                path: '/group-chat-responsibles',
                title: 'groupChatResponsible',
                permission: 'view-group-chat-responsibles'
              },
              {
                title: 'disciplinary',
                icon: '',
                children: [
                  {
                    path: 'disciplinary-sub-types',
                    title: 'subType',
                    permission: ''
                  },
                  {
                    path: 'disciplinary-activities',
                    title: 'activitiy',
                    permission: ''
                  },
                  {
                    path: 'disciplinary-conditions',
                    title: 'condition',
                    permission: ''
                  }
                ]
              },
              {
                path: '/comments',
                title: 'comment',
                permission: 'view-comments'
              }
            ]
          },
          {
            title: 'setting',
            icon: '',
            children: [
              {
                path: '/attendance-settings',
                title: 'GeneralSetting',
                permission: 'view-attendance-settings'
              },
              {
                path: '/events',
                title: 'eventActivity',
                permission: 'view-events'
              },
              {
                title: 'scoring',
                icon: '',
                children: [
                  {
                    path: '/score-assessments',
                    title: 'scoreAssessment',
                    permission: 'view-score-assessments'
                  },
                  {
                    path: '/total-score-grading-ranges',
                    title: 'totalScoreGrading',
                    permission: 'view-total-score-grading-ranges'
                  },
                  {
                    path: 'subject-grading-ranges',
                    title: 'subjectGrading',
                    permission: 'view-subject-grading-ranges'
                  },
                  {
                    path: '/v2/monthly-semester-mappings',
                    title: 'monthlySemesterMapping',
                    permission: 'view-monthly-semester-mappings'
                  }
                ]
              },
              {
                path: '/scholarships',
                title: 'scholarship',
                permission: 'view-scholarships'
              },
              {
                path: '/school-contacts',
                title: 'schoolContact',
                permission: 'view-school-contacts'
              },
              {
                path: '/exam-schedules',
                title: 'examSchedule',
                permission: 'view-exam-schedules'
              },
              {
                path: '/signatures',
                title: 'signature',
                permission: 'view-signatures'
              }
            ]
          },
          {
            title: 'operation',
            icon: '',
            children: [
              {
                path: '/class-operations',
                title: 'classOperation',
                permission: 'view-class-operations'
              },
              {
                title: 'profilesMGT',
                icon: '',
                children: [
                  {
                    path: '/parent-profiles',
                    title: 'parentProfile',
                    permission: 'view-parent-profiles'
                  },
                  {
                    path: '/student-profiles',
                    title: 'studentProfile',
                    permission: 'view-student-profiles'
                  },
                  {
                    path: '/student-card-activators',
                    title: 'cardActivator',
                    permission: 'view-student-card-activators'
                  },
                  {
                    path: '/teacher-profiles',
                    title: 'teacherProfile',
                    permission: 'view-teacher-profiles'
                  },
                  {
                    path: '/student-accidents',
                    title: 'studentAccident',
                    permission: ''
                  },
                  {
                    path: '/student-transfers',
                    title: 'studentTransfer',
                    permission: 'view-student-transfers'
                  }
                ]
              },
              {
                title: 'studentHealth',
                icon: '',
                children: [
                  {
                    path: '/health-categories',
                    title: 'healthCategory',
                    permission: 'view-health-categories'
                  },
                  {
                    path: '/health-items',
                    title: 'healthItem',
                    permission: 'view-health-items'
                  },
                  {
                    path: '/hospital-profiles',
                    title: 'hospitalProfile',
                    permission: 'view-hospital-profiles'
                  },
                  {
                    path: '/student-healths',
                    title: 'studentHealth',
                    permission: 'view-student-healths'
                  }
                ]
              },
              {
                path: '/schedules',
                title: 'schedule',
                permission: 'view-schedules'
              },
              // children: [
              //   {
              //     path: '/teacher-subject-codes',
              //     title: 'teacherSubjectCode',
              //     permission: 'view-teacher-subject-codes'
              //   },
              //   {
              //     path: '/khmer-secondary-schedules',
              //     title: 'khmerSecondary',
              //     permission: 'view-khmer-secondary-schedules'
              //   },
              //   {
              //     path: '/schedules',
              //     title: 'otherProgram',
              //     permission: 'view-schedules'
              //   }
              // ]
              {
                path: '/student-enrollments',
                title: 'studentEnrollment',
                permission: 'view-student-enrollments'
              },
              {
                title: 'studentPickup',
                icon: '',
                children: [
                  {
                    path: '/pickup-card-creations',
                    title: 'pickupCardCreation',
                    permission: 'view-pickup-card-creations'
                  },
                  {
                    path: '/pickup-card-activators',
                    title: 'cardActivator',
                    permission: 'view-pickup-card-activators'
                  },
                  {
                    path: '/pickup-histories',
                    title: 'pickupHistory',
                    permission: 'view-pickup-histories'
                  },
                  {
                    path: '/pickup-displays',
                    title: 'pickupDisplay',
                    permission: 'view-pickup-displays'
                  }
                  // {
                  //   path: '/invalidation-histories',
                  //   title: 'invalidationHistory',
                  //   permission: ''
                  // },
                  // {
                  //   path: '/car-pickup-histories',
                  //   title: 'carPickupHistory',
                  //   permission: ''
                  // }
                ]
              },
              {
                title: 'attendance',
                icon: '',
                children: [
                  {
                    path: '/campus-attendances',
                    title: 'campusAttendance',
                    permission: 'view-campus-attendances'
                  },
                  // {
                  //   path: '/class-attendances',
                  //   title: 'classAttendance',
                  //   permission: 'view-class-attendances'
                  // },
                  {
                    path: '/v2/class-attendances',
                    title: 'classAttendance',
                    permission: 'view-class-attendances'
                  },
                  {
                    path: '/car-attendances',
                    title: 'carAttendance',
                    permission: 'view-car-attendances'
                  },
                  {
                    path: '/teaching-calendars',
                    title: 'teachingCalendar',
                    permission: 'view-teaching-calendars'
                  }
                ]
              },
              {
                title: 'studentScore',
                icon: '',
                children: [
                  {
                    path: '/student-scoring-entries',
                    title: 'scoreEntry',
                    permission: 'view-student-scoring-entries'
                  },
                  {
                    path: '/student-scoring-component-entries',
                    title: 'scoreComponentEntry',
                    permission: 'view-student-scoring-component-entries'
                  },
                  {
                    path: '/generate-total-scores',
                    title: 'generateTotalScore',
                    permission: 'view-generate-total-scores'
                  }
                ]
              },
              {
                path: '/calendars',
                title: 'calendar',
                permission: 'view-calendars'
              },
              {
                path: '/homeworks',
                title: 'homework',
                permission: 'view-homeworks'
              },
              {
                title: 'eExams',
                icon: '',
                children: [
                  {
                    path: '/questions',
                    title: 'questions',
                    permission: 'view-questions'
                  },
                  {
                    path: '/exams',
                    title: 'exams',
                    permission: 'view-exams'
                  }
                ]
              },
              {
                path: '/card-to-be-prints',
                title: 'cardToBePrint',
                permission: 'view-card-to-be-prints'
              },
              {
                path: '/chats',
                title: 'chat',
                permission: 'view-chats'
              },
              {
                path: '/student-galleries',
                title: 'studentGallery',
                permission: 'view-student-galleries'
              },
              {
                path: '/year-books',
                title: 'yearBook',
                permission: 'view-year-books'
              },
              // {
              //   path: '/portfolio-photos',
              //   title: 'portfolioPhoto',
              //   permission: 'view-portfolio-photos'
              // }
              {
                title: 'studentPortfolio',
                icon: '',
                children: [
                  {
                    path: '/portfolio-photos',
                    title: 'portfolioPhoto',
                    permission: 'view-portfolio-photos'
                  },
                  {
                    path: '/portfolio-preview-lists',
                    title: 'portfolioReview',
                    permission: 'view-portfolio-review-photos'
                  }
                ]
              },
              {
                path: '/event-invitations',
                title: 'eventInvitation',
                permission: 'view-event-invitations'
              },
              {
                path: '/disciplinary-actions',
                title: 'disciplinaryAction',
                permission: 'view-disciplinary-actions'
              },
              {
                path: '/certificate-operation-prints',
                title: 'certificateOperationPrint',
                permission: 'view-certificate-operation-prints'
              }
            ]
          }
        ]
      },
      {
        title: 'transportation',
        icon: '',
        children: [
          {
            path: '/vehicle-profiles',
            title: 'vehicleProfile',
            permission: 'view-vehicle-profiles'
          },
          {
            path: '/transportation-distances',
            title: 'distance',
            permission: 'view-transportation-distances'
          },
          {
            path: '/way-transportations',
            title: 'transportationWay',
            permission: 'view-way-transportations'
          },
          {
            path: '/vehicle-zone-profiles',
            title: 'zoneProfile',
            permission: 'view-vehicle-zone-profiles'
          },
          {
            path: '/vehicle-operations',
            title: 'vehicleOperation',
            permission: 'view-vehicle-operations'
          },
          {
            path: '/student-vehicles',
            title: 'studentVehicle',
            permission: 'view-student-vehicles'
          }
        ]
      },
      {
        title: 'payment',
        icon: '',
        children: [
          {
            title: 'setup',
            icon: '',
            children: [
              {
                path: '/fee-types',
                title: 'feeType',
                permission: 'view-fee-types'
              },
              {
                path: '/fee-setups',
                title: 'feeSetup',
                permission: 'view-fee-setups'
              },
              {
                path: '/fee-groups',
                title: 'feeGroup',
                permission: 'view-fee-groups'
              },
              {
                path: '/bank-profiles',
                title: 'bankProfile',
                permission: 'view-bank-profiles'
              }
            ]
          },
          {
            title: 'operation',
            icon: '',
            children: [
              {
                path: '/service-subscriptions',
                title: 'serviceSubscription',
                permission: 'view-service-subscriptions'
              },
              {
                path: '/quotations',
                title: 'quotation',
                permission: 'view-quotations'
              },
              {
                path: '/pre-invoices',
                title: 'preInvoice',
                permission: 'view-pre-invoices'
              },
              {
                path: '/invoices',
                title: 'invoice',
                permission: 'view-invoices'
              },
              {
                path: '/invoice-classes',
                title: 'invoiceClasses',
                permission: 'view-invoice-classes'
              },
              {
                path: '/invoice-confirm',
                title: 'invoiceConfirm',
                permission: 'view-invoice-confirms'
              },
              {
                path: '/receipts',
                title: 'receipt',
                permission: 'view-receipts'
              },
              {
                path: '/retail-sales',
                title: 'retailSale',
                permission: 'view-retail-sales'
              },
              {
                path: '/new-student-unpaids',
                title: 'newStudentUnpaids',
                permission: 'view-new-student-unpaids'
              },
              {
                path: '/payment-adjustments',
                title: 'adjustment',
                permission: 'view-payment-adjustments'
              },
              {
                path: '/payment-testing',
                title: 'testing',
                permission: 'view-payment-testing'
              },
              {
                path: '/student-invoices',
                title: 'studentInvoice',
                permission: 'view-student-invoices'
              }
            ]
          },
          {
            title: 'setting',
            icon: '',
            children: [
              {
                path: '/default-credit-days',
                title: 'defaultCreditDay',
                permission: 'view-default-credit-days'
              },
              {
                path: '/promotions',
                title: 'promotion',
                permission: 'view-promotions'
              },
              {
                path: '/payment-announcements',
                title: 'announcement',
                permission: 'view-payment-announcements'
              }
            ]
          }
        ]
      },
      {
        title: 'report',
        children: [
          {
            title: 'academic',
            children: [
              {
                path: '/report/info-inquiries',
                title: 'infoInquiry',
                permission: 'view-info-inquiry'
              },
              {
                path: '/report/inquiry-follow-ups',
                title: 'inquiryFollowUp',
                permission: 'view-report-student-follow-ups'
              },
              {
                path: '/report/student-lists',
                title: 'studentList',
                permission: 'view-student-lists'
              },
              {
                path: '/report/student-list-for-moeys',
                title: 'studentListMoEYS',
                permission: 'view-student-list-for-moeys'
              },
              {
                path: '/report/student-transfers',
                title: 'studentTransfer',
                permission: 'view-report-student-transfers'
              },
              {
                path: '/report/student-enrollments',
                title: 'studentEnrollment',
                permission: 'view-report-student-enrollments'
              },
              {
                path: '/report/transportation-lists',
                title: 'transportationList',
                permission: 'view-transportations'
              },
              {
                path: '/report/class-teaching',
                title: 'classTeaching',
                permission: 'view-class-teaching'
              },
              {
                path: '/report/inactive-students',
                title: 'inactiveStudent',
                permission: 'view-inactive-students'
              },
              {
                path: '/report/student-exchanges',
                title: 'studentExchange',
                permission: 'view-student-exchanges'
              },

              {
                path: '/report/report-class-attendances',
                title: 'reportClassAttendances',
                permission: 'view-report-class-attendances'
              },
              {
                title: 'studentScore',
                icon: '',
                children: [
                  {
                    path: '/report/report-scorings',
                    title: 'reportScoring',
                    permission: 'view-report-scorings'
                  },
                  {
                    path: '/report/report-cards',
                    title: 'reportCards',
                    permission: 'view-report-cards'
                  }
                  // {
                  //   title: 'khmerProgram',
                  //   icon: '',
                  //   children: [
                  //     {
                  //       path: '/report/score-result-list-khmers',
                  //       title: 'scoreResultList',
                  //       permission: 'view-report-scoring-khmers'
                  //     },
                  //     {
                  //       path: '/report/report-card-khmers',
                  //       title: 'reportCards',
                  //       permission: 'view-report-card-khmers'
                  //     }
                  //   ]
                  // },
                  // {
                  //   title: 'englishProgram',
                  //   icon: '',
                  //   children: [
                  //     {
                  //       path: '/report/score-result-list-englishs',
                  //       title: 'scoreResultList',
                  //       permission: 'view-report-scoring-englishs'
                  //     },
                  //     {
                  //       path: '/report/report-card-englishs',
                  //       title: 'reportCards',
                  //       permission: 'view-report-card-englishs'
                  //     }
                  //   ]
                  // }
                ]
              },
              {
                path: '/report/student-achievement-results',
                title: 'studentAchievementResults',
                permission: 'view-report-student-achievement-result'
              },
              // {
              //   path: '/report/part-time-of-monthlies',
              //   title: 'partTimeOfMonthly',
              //   permission: 'view-report-part-time-of-monthlyies'
              // },
              {
                path: '/report/student-score-sheets',
                title: 'studentScoreSheet',
                permission: 'view-report-student-score-sheets'
              },
              {
                path: '/report/student-score-performance-by-subjects',
                title: 'studentPerformanceBySubject',
                permission: 'view-report-student-performance-by-subjects'
              },
              {
                path: '/report/student-total-score-performances',
                title: 'studentTotalScorePerformance',
                permission: 'view-report-student-total-score-performances'
              }
            ]
          },
          {
            title: 'payment',
            children: [
              {
                path: '/report/daily-closeout',
                title: 'dailyCloseout',
                permission: 'view-daily-closeout'
              },
              {
                path: '/report/payment-details',
                title: 'paymentDetail',
                permission: 'view-payment-details'
              },
              {
                path: '/report/summary-cash-collections',
                title: 'summaryCashCollection',
                permission: 'view-summary-cash-collections'
              },
              {
                path: '/report/cash-collection-by-cashiers',
                title: 'cashCollectionByCashier',
                permission: 'view-cash-collection-by-cashiers'
              },
              {
                path: '/report/payment-by-services',
                title: 'paymentByService',
                permission: 'view-payment-by-services'
              },
              {
                path: '/report/monthly-payments',
                title: 'monthlyPayment',
                permission: 'view-monthly-payments'
              },
              {
                path: '/report/student-unpaids',
                title: 'studentUnpaid',
                permission: 'view-student-unpaids'
              },
              {
                path: '/report/void-invoices',
                title: 'voidedInvoice',
                permission: 'view-void-invoices'
              },
              {
                path: '/report/annual-payments',
                title: 'annualPayment',
                permission: 'view-annual-payments'
              },
              {
                path: '/report/overdue-payments',
                title: 'overduePayment',
                permission: 'view-overdue-payments'
              },
              {
                path: '/report/student-payments',
                title: 'studentPayment',
                permission: 'view-student-payments'
              },
              {
                path: '/report/discount-payments',
                title: 'discountPayment',
                permission: 'view-discount-payments'
              },
              {
                path: '/report/yearly-payment-lists',
                title: 'yearlyPaymentList',
                permission: 'view-yearly-payment-lists'
              },
              {
                path: '/report/sale-day-books',
                title: 'saleDayBook',
                permission: 'view-sale-day-books'
              },
              {
                path: '/report/payment-trackings',
                title: 'paymentTracking',
                permission: 'view-payment-trackings'
              }
            ]
          },
          {
            title: 'employee',
            children: [
              {
                path: '/report/employee-daily-timescans',
                title: 'reportEmployeeDailyTimescan',
                permission: 'view-report-employee-daily-timescans'
              },
              {
                path: '/report/leave-summarys',
                title: 'leaveSummrayReport',
                permission: 'view-report-leave-summarys'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: 'inventory',
    icon: 'fas fa-warehouse',
    children: [
      {
        title: 'setup',
        icon: '',
        children: [
          {
            path: '/warehouses',
            title: 'warehouse',
            permission: 'view-warehouses'
          },
          {
            title: 'product',
            icon: '',
            children: [
              {
                path: '/categories',
                title: 'category',
                permission: 'view-categories'
              },
              {
                path: '/suppliers',
                title: 'supplier',
                permission: 'view-suppliers'
              },
              {
                path: '/unit-of-measures',
                title: 'unitOfMeasure',
                permission: 'view-uom-categories'
              },
              {
                path: '/products',
                title: 'profile',
                permission: 'view-products'
              },
              {
                path: '/product-locations',
                title: 'productLocation',
                permission: 'view-product-locations'
              }
            ]
          },
          {
            path: '/location-settlements',
            title: 'locationSettlement',
            permission: 'view-location-settlements'
          }
        ]
      },
      {
        title: 'operation',
        icon: '',
        children: [
          {
            path: '/purchase-orders',
            title: 'purchaseOrder',
            permission: 'view-purchase-orders'
          },
          {
            path: '/stock-ins',
            title: 'stockIn',
            permission: 'view-stock-ins'
          },
          {
            path: '/stock-transfers',
            title: 'stockTransfer',
            permission: 'view-stock-transfers'
          },
          {
            path: '/stock-count-entries',
            title: 'stockCountEntry',
            permission: 'view-stock-count-entries'
          },
          {
            path: '/stock-adjustments',
            title: 'stockAdjustment',
            permission: 'view-stock-adjustments'
          },
          {
            path: '/inventory-lists',
            title: 'inventoryList',
            permission: 'view-inventory-table-lists'
          },
          {
            path: '/product-movements',
            title: 'productMovement',
            permission: 'view-product-movements'
          }
        ]
      },
      {
        title: 'report',
        icon: '',
        children: [
          {
            path: '/report/daily-sale-items',
            title: 'dailySaleItem',
            permission: 'view-daily-sale-items'
          },
          {
            path: '/report/sale-item-details',
            title: 'saleItemDetail',
            permission: 'view-sale-item-details'
          },
          {
            path: '/report/stock-in-details',
            title: 'stockInDetail',
            permission: 'view-stock-in-details'
          },
          {
            path: '/report/stock-in-summaries',
            title: 'stockInSummary',
            permission: 'view-stock-in-summaries'
          },
          {
            path: '/report/inventory-list-head-offices',
            title: 'hoInventoryList',
            permission: 'view-inventory-list-head-offices'
          },
          {
            path: '/report/detail-inventory-lists',
            title: 'detailInventoryList',
            permission: 'view-detail-inventory-lists'
          },
          {
            path: '/report/summary-inventory-lists',
            title: 'summaryInventoryList',
            permission: 'view-summary-inventory-lists'
          },
          {
            path: '/report/product-item-lists',
            title: 'productItemList',
            permission: 'view-product-item-lists'
          },
          {
            path: '/report/purchase-order-lists',
            title: 'poList',
            permission: 'view-purchase-order-lists'
          },
          {
            path: '/report/purchase-order-summaries',
            title: 'poSummary',
            permission: 'view-purchase-order-summaries'
          },
          {
            path: '/report/monthly-sale-items',
            title: 'monthlySaleItem',
            permission: 'view-monthly-sale-items'
          },
          {
            path: '/report/stock-transfers',
            title: 'stockTransfer',
            permission: 'view-report-stock-transfers'
          },
          {
            path: '/report/yearly-sale-items',
            title: 'yearlySaleItem',
            permission: 'view-yearly-sale-items'
          }
        ]
      }
    ]
  },
  {
    title: 'security',
    icon: 'fas fa-shield-alt',
    children: [
      { path: '/roles', title: 'role', permission: 'view-roles' },
      { path: '/users', title: 'user', permission: 'view-users' },
      {
        path: '/history-tracking',
        title: 'historyTracking',
        permission: 'view-history-tracking'
      }
    ]
  }
]
